import * as React from 'react';
import { Input as AntInput } from 'antd';
import { PasswordProps as AntPasswordProps } from 'antd/lib/input';

export type PasswordProps = {
  placeholder?: string;
  id?: string;
  visibilityToggle: boolean;
  iconRender?: (visible: boolean) => React.ReactNode;
  size: 'large' | 'middle' | 'small';
};

const Password = (props: PasswordProps & AntPasswordProps) => {
  const { className } = props;
  const classNames = [className, 'input', 'password'];
  return <AntInput.Password {...props} className={classNames.join(' ')} />;
};

Password.defaultProps = {
  visibilityToggle: true,
  size: 'middle',
};

export default Password;
